<template>
  <div class="card-container channel">
    <el-card>
      <common-el-form
        :model="formModel"
        :rules="formRules"
        :submitData="submitData"
        @success="onSuccess"
        submit-btn-text="提交"
        failTitle="提交失败"
        loadingText="提交中..."
        :submitService="submitService"
        :showButton="false"
      >
        <span>初级合伙人</span>
        <div style="width: 400px; margin-bottom: 35px">
          <el-form-item label="直推购买人数" prop="primaryDirectNum">
            <el-input-number
              v-model="formModel.primaryDirectNum"
              :min="1"
              :max="999999999"
              :step="0"
              :precision="0"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
        </div>
        <div style="display: flex">
          <el-form-item label="赠送T级别" prop="primaryPartnerLevelId">
            <el-select
              style="width: 180px"
              v-model="formModel.primaryPartnerLevelId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in levelNameList"
                :key="item.id"
                :label="item.levelName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div style="width: 400px; margin-left: 30px">
            <el-form-item
              label="T级别保护期（月）"
              prop="primaryPartnerLevelMonth"
            >
              <el-input-number
                v-model="formModel.primaryPartnerLevelMonth"
                :min="0"
                :max="999999999"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <div style="display: flex; flex-wrap: wrap">
          <div style="width: 310px">
            <el-form-item label="平台利润占比（%）" prop="primaryTotalPercent">
              <el-input-number
                style="width: 132px"
                v-model="formModel.primaryTotalPercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="width: 350px">
            <el-form-item label="平均分红占比（%）" prop="primaryAvgPercent">
              <el-input-number
                style="width: 132px"
                v-model="formModel.primaryAvgPercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="width: 350px">
            <el-form-item
              label="业绩分红占比（%）"
              prop="primaryPerformancePercent"
            >
              <el-input-number
                style="width: 132px"
                v-model="formModel.primaryPerformancePercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <span>中级合伙人</span>
        <div style="width: 400px; margin-bottom: 35px">
          <el-form-item label="直推购买人数" prop="midDirectNum">
            <el-input-number
              v-model="formModel.midDirectNum"
              :min="1"
              :max="999999999"
              :step="0"
              :precision="0"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
        </div>
        <div style="display: flex">
          <el-form-item label="赠送T级别" prop="midPartnerLevelId">
            <el-select
              style="width: 180px"
              v-model="formModel.midPartnerLevelId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in levelNameList"
                :key="item.id"
                :label="item.levelName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div style="width: 400px; margin-left: 30px">
            <el-form-item label="T级别保护期（月）" prop="midPartnerLevelMonth">
              <el-input-number
                v-model="formModel.midPartnerLevelMonth"
                :min="0"
                :max="999999999"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <div style="display: flex; flex-wrap: wrap">
          <div style="width: 310px">
            <el-form-item label="平台利润占比（%）" prop="midTotalPercent">
              <el-input-number
                style="width: 132px"
                v-model="formModel.midTotalPercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="width: 350px">
            <el-form-item label="平均分红占比（%）" prop="midAvgPercent">
              <el-input-number
                style="width: 132px"
                v-model="formModel.midAvgPercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="width: 350px">
            <el-form-item
              label="业绩分红占比（%）"
              prop="midPerformancePercent"
            >
              <el-input-number
                style="width: 132px"
                v-model="formModel.midPerformancePercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <span>高级合伙人</span>
        <div style="width: 400px; margin-bottom: 35px">
          <el-form-item label="直推购买人数" prop="highDirectNum">
            <el-input-number
              v-model="formModel.highDirectNum"
              :min="1"
              :max="999999999"
              :step="0"
              :precision="0"
              :controls="false"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
        </div>
        <div style="display: flex">
          <el-form-item label="赠送T级别" prop="highPartnerLevelId">
            <el-select
              style="width: 180px"
              v-model="formModel.highPartnerLevelId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in levelNameList"
                :key="item.id"
                :label="item.levelName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div style="width: 400px; margin-left: 30px">
            <el-form-item
              label="T级别保护期（月）"
              prop="highPartnerLevelMonth"
            >
              <el-input-number
                v-model="formModel.highPartnerLevelMonth"
                :min="0"
                :max="999999999"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <div style="display: flex; flex-wrap: wrap">
          <div style="width: 310px">
            <el-form-item label="平台利润占比（%）" prop="highTotalPercent">
              <el-input-number
                style="width: 132px"
                v-model="formModel.highTotalPercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="width: 350px">
            <el-form-item label="平均分红占比（%）" prop="highAvgPercent">
              <el-input-number
                style="width: 132px"
                v-model="formModel.highAvgPercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="width: 350px">
            <el-form-item
              label="业绩分红占比（%）"
              prop="highPerformancePercent"
            >
              <el-input-number
                style="width: 132px"
                v-model="formModel.highPerformancePercent"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="开关" prop="status">
          <el-switch
            v-model="formModel.status"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </common-el-form>
    </el-card>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import SelectLevel from "components/business/SelectLevel";
import ElFormItem from "element-ui/packages/form/src/form-item";
import OrganService from "service/OrganService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "partnerlevelmanage",
  data() {
    return {
      levelNameList: [],
      formRules: {
        primaryDirectNum: [
          {
            required: true,
            validator: this.validatePrimaryNum,
          },
          // { validator: this.validatePrimaryNum },
        ],
        primaryPartnerLevelId: [
          {
            required: true,
            message: "请选择",
          },
        ],
        primaryPartnerLevelMonth: [
          {
            required: true,
            message: "请输入",
          },
        ],
        primaryTotalPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        primaryAvgPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        primaryPerformancePercent: [
          {
            required: true,
            message: "请输入",
          },
        ],

        midDirectNum: [
          {
            required: true,
            validator: this.validateMidNum,
          },
          // { validator: this.validateMidNum },
        ],
        midPartnerLevelId: [
          {
            required: true,
            message: "请选择",
          },
        ],
        midPartnerLevelMonth: [
          {
            required: true,
            message: "请输入",
          },
        ],
        midAvgPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        midTotalPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        midPerformancePercent: [
          {
            required: true,
            message: "请输入",
          },
        ],

        highDirectNum: [
          {
            required: true,
            validator: this.validateHighNum,
          },
          // { validator: this.validateHighNum },
        ],
        highPartnerLevelId: [
          {
            required: true,
            message: "请选择",
          },
        ],
        highPartnerLevelMonth: [
          {
            required: true,
            message: "请输入",
          },
        ],
        highTotalPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        highAvgPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        highPerformancePercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      formModel: {
        primaryDirectNum: undefined,
        primaryPartnerLevelId: "",
        primaryPartnerLevelMonth: undefined,
        primaryTotalPercent: undefined,
        primaryAvgPercent: undefined,
        primaryPerformancePercent: undefined,

        midDirectNum: undefined,
        midPartnerLevelId: "",
        midPartnerLevelMonth: undefined,
        midTotalPercent: undefined,
        midAvgPercent: undefined,
        midPerformancePercent: undefined,

        highDirectNum: undefined,
        highPartnerLevelId: "",
        highPartnerLevelMonth: undefined,
        highTotalPercent: undefined,
        highAvgPercent: undefined,
        highPerformancePercent: undefined,

        status: 1,
        id: "",
      },
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    ElFormItem,
    CommonElForm,
    SelectLevel,
  },
  computed: {
    submitData() {
      this.params = {
        primaryDirectNum: this.formModel.primaryDirectNum,
        primaryPartnerLevelId: this.formModel.primaryPartnerLevelId,
        primaryPartnerLevelMonth: this.formModel.primaryPartnerLevelMonth,
        primaryTotalPercent: this.formModel.primaryTotalPercent,
        primaryAvgPercent: this.formModel.primaryAvgPercent,
        primaryPerformancePercent: this.formModel.primaryPerformancePercent,

        midDirectNum: this.formModel.midDirectNum,
        midPartnerLevelId: this.formModel.midPartnerLevelId,
        midPartnerLevelMonth: this.formModel.midPartnerLevelMonth,
        midTotalPercent: this.formModel.midTotalPercent,
        midAvgPercent: this.formModel.midAvgPercent,
        midPerformancePercent: this.formModel.midPerformancePercent,

        highDirectNum: this.formModel.highDirectNum,
        highPartnerLevelId: this.formModel.highPartnerLevelId,
        highPartnerLevelMonth: this.formModel.highPartnerLevelMonth,
        highTotalPercent: this.formModel.highTotalPercent,
        highAvgPercent: this.formModel.highAvgPercent,
        highPerformancePercent: this.formModel.highPerformancePercent,

        id: this.formModel.id,
        status: this.formModel.status,
      };
      return this.params;
    },
    submitService() {
      return OrganService.partnerlevelmanageUpdate;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.getDetail();
    this.getLevelNameList();
  },
  methods: {
    validatePrimaryNum(rule, value, callback) {
      const mid = this.formModel.midDirectNum;
      const high = this.formModel.highDirectNum;
      if (value && mid && high) {
        if (value >= mid) {
          callback(
            new Error("初级合伙人直推购买人数必须小于中级合伙人直推购买人数")
          );
        } else if (mid >= high) {
          callback(
            new Error("中级合伙人直推购买人数必须小于高级合伙人直推购买人数")
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    validateMidNum(rule, value, callback) {
      const primary = this.formModel.primaryDirectNum;
      const high = this.formModel.highDirectNum;
      if (value && primary && high) {
        if (primary >= value) {
          callback(
            new Error("初级合伙人直推购买人数必须小于中级合伙人直推购买人数")
          );
        } else if (value >= high) {
          callback(
            new Error("中级合伙人直推购买人数必须小于高级合伙人直推购买人数")
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    validateHighNum(rule, value, callback) {
      const primary = this.formModel.primaryDirectNum;
      const mid = this.formModel.midDirectNum;
      console.log();
      if (value && primary && mid) {
        if (primary >= mid) {
          callback(
            new Error("初级合伙人直推购买人数必须小于中级合伙人直推购买人数")
          );
        } else if (mid >= value) {
          callback(
            new Error("中级合伙人直推购买人数必须小于高级合伙人直推购买人数")
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    getDetail() {
      this.doLoad(
        OrganService.partnerlevelmanageList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.formModel = result;
          });
        },
        "信息获取失败"
      );
    },
    getLevelNameList() {
      this.doLoad(
        OrganService.memberupgradeList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.levelNameList = [
              ...[
                {
                  id: 0,
                  levelName: "未选择",
                },
              ],
              ...result.rows,
            ];
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        this.getDetail();
        this.showSuccess(res.contents.optMsg);
      });
    },
    ...mapActions({}),
  },
};
</script>

<style scoped>
span {
  font-size: 17px;
  margin-bottom: 10px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/PartnerLevelManage.vue